import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/symbol';
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
//import registerServiceWorker from './registerServiceWorker'

import { BrowserRouter } from 'react-router-dom';

ReactDOM.render((
    <BrowserRouter>
        <App />
    </BrowserRouter>
), document.getElementById('root'))

//registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js